import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extending the summTreeColumn filter for custom aggregation
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the filter display with aggregated values.
                 * @param {Object} master - The master view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value to aggregate.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the aggregation result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Aggregate values at level 1
                    });
                    // Format the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node display
                },
            },
            webix.ui.datafilter.summColumn, // Extend from the existing summColumn filter
        );

        return {
            view: 'treetable', // Define the view type
            id: 'treetable', // Unique identifier for the treetable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            columns: [
                // Define the columns for the treetable
                {
                    id: 'TypeName', // Unique identifier for the column
                    header: 'TypeName', // Header text for the column
                    width: 350, // Column width
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Display group name
                        return obj.NameAffiliate; // Display affiliate name
                    },
                },
                {
                    id: 'ActionTittle', // Unique identifier for the action column
                    header: '', // No header text
                    width: 70, // Column width
                    height: 25, // Column height
                    tooltip: 'Acción', // Tooltip text
                    template: function (obj) {
                        // Conditional rendering of action buttons based on state and level
                        if ((obj.State == 'A' || obj.State == null) && obj.$level == 5) {
                            if (devConfig.getPermAction('comissionsReportBetShopApprove', 'Approve')) {
                                return "<span placeholder='Aprobar' class='webix_icon wxi-close approve prm-comissionsReportBetShopApprove'></span><span class='webix_icon icon-history torefuse prm-comissionsReportBetShopApprove'></span>";
                            } else {
                                return '';
                            }
                        } else {
                            if ((obj.State == 'P' || obj.State == null) && obj.$level == 5) {
                                if (devConfig.getPermAction('comissionsReportBetShopPay', 'Pay')) {
                                    return "<span placeholder='Pagar' class='webix_icon wxi-close pay prm-comissionsReportBetShopPay'></span>";
                                } else {
                                    return '';
                                }
                            } else {
                                return '';
                            }
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // Column for ID
                {
                    id: 'ClientId',
                    header: _('ID Afiliador'), // Localized header for Affiliate ID
                    width: 95,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'NameAffiliate',
                    header: _('Nombre Afiliador'), // Localized header for Affiliate Name
                    width: 200,
                    sort: 'int',
                    hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Conditional visibility based on permissions
                },
                {
                    id: 'ClientRef',
                    header: _('Usuario REF'), // Localized header for REF User
                    width: 95,
                    sort: 'int',
                },
                {
                    id: 'NameClientRef',
                    header: _('Nombre Usuario REF'), // Localized header for REF User Name
                    width: 200,
                    sort: 'int',
                    hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Conditional visibility based on permissions
                },
                {
                    id: 'CreatedLocal',
                    header: _('Fecha de creación'), // Localized header for Creation Date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'CurrencyId',
                    header: _('Moneda'), // Localized header for Currency
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Bets',
                    header: _('Apuestas'), // Localized header for Bets
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }), // Number formatting for Bets
                    editor: 'text', // Editable field
                },
                {
                    id: 'Winnings',
                    header: _('Premios'), // Localized header for Winnings
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }), // Number formatting for Winnings
                    editor: 'text', // Editable field
                },
                {
                    id: 'Bonus',
                    header: _('Bonos'), // Localized header for Bonuses
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }), // Number formatting for Bonuses
                    editor: 'text', // Editable field
                },
                {
                    id: 'AmountBase',
                    header: _('Valor Base'), // Localized header for Base Value
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }), // Number formatting for Base Value
                    editor: 'text', // Editable field
                },
                {
                    id: 'Amount',
                    header: _('Comision'), // Localized header for Commission
                    width: 100,
                    sort: 'int',
                    editor: 'text', // Editable field
                    template: function (obj) {
                        var format = webix.Number.numToStr({
                            groupDelimiter: ',',
                            groupSize: 3,
                            decimalDelimiter: '.',
                            decimalSize: 2,
                        });
                        if (parseInt(obj.Amount) < 0 && obj.$level == 2) {
                            return format('0'); // Display '0' for negative amounts at level 2
                        } else {
                            return format(obj.Amount); // Format and return the amount
                        }
                    },
                },
                {
                    id: 'PlatformCost',
                    header: _('Costo Plataforma'), // Localized header for Platform Cost
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }), // Number formatting for Platform Cost
                    editor: 'text', // Editable field
                },
                {
                    id: 'AmountPaid',
                    header: _('Valor Pagado'), // Localized header for Amount Paid
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }), // Number formatting for Amount Paid
                    editor: 'text', // Editable field
                },
                {
                    id: 'State',
                    header: _('Estado'), // Localized header for State
                    options: [
                        { id: '', value: _('None') }, // Option for no state
                        { id: 'A', value: _('Activo') }, // Active state
                        { id: 'I', value: _('Pagada') }, // Paid state
                        { id: 'P', value: _('Pendiente') }, // Pending state
                        { id: 'R', value: _('Rechazada') }, // Rejected state
                    ],
                },
                {
                    id: 'ModifiedLocal',
                    header: _('Modificado'), // Localized header for Modified Date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
            ],
            onClick: {
                /**
                 * Handles the click event for payment actions.
                 * @param {Event} euv - The event object.
                 * @param {String} id - The ID of the clicked item.
                 */
                pay: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix
                        .modalbox({
                            title: _('Pregunta '), // Modal title
                            buttons: [
                                _('Efectivo'), // Cash option
                                _('Saldo Recarga'), // Recharge balance option
                                _('Saldo Juego'), // Game balance option
                                _('Saldo Afiliados'), // Affiliate balance option
                                _('Cancelar'), // Cancel option
                            ],
                            text: _('Seleccione el tipo de saldo '), // Modal text
                            width: 500,
                        })
                        .then(function (result) {
                            switch (result) {
                                case '0':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea pagar comisión en efectivo?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item data
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"0"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to 'Paid'
                                                                    webix.message(
                                                                        _(
                                                                            'Comisión Pagada', // Success message
                                                                        ),
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Create a new window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _(
                                                                                            'Factura', // Invoice label
                                                                                        ),
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse the new PDF data
                                                                        });
                                                                    };
                                                                    /**
                                                                     * Converts base64 data to a Blob object.
                                                                     * @param {String} b64Data - Base64 encoded data.
                                                                     * @param {String} contentType - MIME type of the data.
                                                                     * @param {Number} sliceSize - Size of each slice.
                                                                     * @returns {Blob} The resulting Blob object.
                                                                     */
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512;
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(byteArray); // Push byte array to the array
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create a Blob object
                                                                        });
                                                                        return blob; // Return the Blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // MIME type for PDF
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to Blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create a URL for the Blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the Blob for debugging
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open a new window for printing
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '1':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo recargas?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item data
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"1"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to 'Paid'
                                                                    webix.message(
                                                                        _(
                                                                            'Comisión Pagada', // Success message
                                                                        ),
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Create a new window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _(
                                                                                            'Factura', // Invoice label
                                                                                        ),
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse the new PDF data
                                                                        });
                                                                    };
                                                                    /**
                                                                     * Converts base64 data to a Blob object.
                                                                     * @param {String} b64Data - Base64 encoded data.
                                                                     * @param {String} contentType - MIME type of the data.
                                                                     * @param {Number} sliceSize - Size of each slice.
                                                                     * @returns {Blob} The resulting Blob object.
                                                                     */
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512;
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(byteArray); // Push byte array to the array
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create a Blob object
                                                                        });
                                                                        return blob; // Return the Blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // MIME type for PDF
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to Blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create a URL for the Blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the Blob for debugging
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open a new window for printing
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '2':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo juego?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item data
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"2"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to 'Paid'
                                                                    webix.message(
                                                                        _(
                                                                            'Comisión Pagada', // Success message
                                                                        ),
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Create a new window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _(
                                                                                            'Factura', // Invoice label
                                                                                        ),
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse the new PDF data
                                                                        });
                                                                    };
                                                                    /**
                                                                     * Converts base64 data to a Blob object.
                                                                     * @param {String} b64Data - Base64 encoded data.
                                                                     * @param {String} contentType - MIME type of the data.
                                                                     * @param {Number} sliceSize - Size of each slice.
                                                                     * @returns {Blob} The resulting Blob object.
                                                                     */
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512;
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(byteArray); // Push byte array to the array
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create a Blob object
                                                                        });
                                                                        return blob; // Return the Blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // MIME type for PDF
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to Blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create a URL for the Blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the Blob for debugging
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open a new window for printing
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '3':
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo afiliados?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item data
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"3"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                data = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Update item state to 'Paid'
                                                                    webix.message(
                                                                        _(
                                                                            'Comisión Pagada', // Success message
                                                                        ),
                                                                    );
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Create a new window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _(
                                                                                            'Factura', // Invoice label
                                                                                        ),
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: "$$('windowfact2').close();", // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // File reader for PDF
                                                                    reader.onload = function (event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parse the new PDF data
                                                                        });
                                                                    };
                                                                    /**
                                                                     * Converts base64 data to a Blob object.
                                                                     * @param {String} b64Data - Base64 encoded data.
                                                                     * @param {String} contentType - MIME type of the data.
                                                                     * @param {Number} sliceSize - Size of each slice.
                                                                     * @returns {Blob} The resulting Blob object.
                                                                     */
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || '';
                                                                        sliceSize = sliceSize || 512;
                                                                        var byteCharacters = atob(
                                                                            b64Data, // Decode base64 data
                                                                        );
                                                                        var byteArrays = [];
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            );
                                                                            var byteNumbers = new Array(slice.length);
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers);
                                                                            byteArrays.push(byteArray); // Push byte array to the array
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Create a Blob object
                                                                        });
                                                                        return blob; // Return the Blob
                                                                    }
                                                                    var contentType = 'application/pdf'; // MIME type for PDF
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(
                                                                        b64Data,
                                                                        contentType, // Convert to Blob
                                                                    );
                                                                    var file = window.URL.createObjectURL(
                                                                        blob, // Create a URL for the Blob
                                                                    );
                                                                    console.log(
                                                                        blob, // Log the Blob for debugging
                                                                    );
                                                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Open a new window for printing
                                                                    );
                                                                    printWindow.print(); // Trigger print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '4':
                                    break; // No action for case 4
                            }
                        });
                },
                /**
                 * Handles the click event for approval actions.
                 * @param {Event} euv - The event object.
                 * @param {String} id - The ID of the clicked item.
                 */
                approve: function (euv, id) {
                    var vthis = this; // Reference to the current context
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Comisión'), // Confirmation text
                        ok: _('Aprobar Comisión'), // Confirm button text
                        cancel: _('Salir'), // Cancel button text
                        callback: function (action) {
                            if (action === true) {
                                var item = vthis.getItem(id); // Get the item data
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Set content type for AJAX request
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Commisions/ApproveComission', // API endpoint for approval
                                        '{ "Id":' + item.Id + '}', // Request payload
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error! ')); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                data = JSON.parse(text); // Parse the response
                                                if (!data.HasError) {
                                                    item.State = 'P'; // Update item state to 'Pending'
                                                    webix.message(
                                                        _('Comision Aprobado'), // Success message
                                                    );
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            on: {
                /**
                 * Event triggered before loading data.
                 */
                onBeforeLoad: function () {
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                /**
                 * Event triggered after loading data.
                 */
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            /**
             * Event triggered when the view is ready.
             */
            ready: function () {
                if (!this.count()) {
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>', // Show no data message
                    );
                }
            },
            tooltip: true, // Enable tooltips
            footer: false, // Disable footer
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Preload data configuration
            pager: 'pagerA', // Pager ID
        };
    }
    /**
     * Initializes the grid and sets up event handlers.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Financial/GetComissionsResume'; // API endpoint for commission resume
        var filter = ''; // Filter string

        // Event triggered after loading data into the grid
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                by: 'NameAffiliate', // Group by Affiliate Name
                map: {
                    NameAffiliate: ['NameAffiliate'],
                    ClientId: ['ClientId'],
                    AmountBase: ['AmountBase', 'sum'], // Sum AmountBase
                    AmountPaid: ['AmountPaid', 'sum'], // Sum AmountPaid
                    PlatformCost: ['PlatformCost', 'sum'], // Sum PlatformCost
                    Amount: ['Amount', 'sum'], // Sum Amount
                    Bets: ['Bets', 'sum'], // Sum Bets
                    Winnings: ['Winnings', 'sum'], // Sum Winnings
                    Bonus: ['Bonus', 'sum'], // Sum Bonus
                    TypeName: ['TypeName'],
                    TypeG: ['TypeG'],
                    CurrencyId: ['CurrencyId'],
                },
            });
            $$('treetable').data.group({
                by: 'TypeName', // Group by Type Name
                map: {
                    TypeName: ['TypeName'],
                    TypeG: ['TypeG'],
                    AmountBase: ['AmountBase', 'sum'], // Sum AmountBase
                    AmountPaid: ['AmountPaid', 'sum'], // Sum AmountPaid
                    PlatformCost: ['PlatformCost', 'sum'], // Sum PlatformCost
                    Amount: ['Amount', 'sum'], // Sum Amount
                    Bets: ['Bets', 'sum'], // Sum Bets
                    Winnings: ['Winnings', 'sum'], // Sum Winnings
                    Bonus: ['Bonus', 'sum'], // Sum Bonus
                    CurrencyId: ['CurrencyId'],
                },
            });
            $$('treetable').data.group({
                by: 'TypeG', // Group by Type Group
                map: {
                    TypeG: ['TypeG'],
                    CurrencyId: ['CurrencyId'],
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'], // Sum AmountPaid
                    PlatformCost: ['PlatformCost', 'sum'], // Sum PlatformCost
                    Amount: ['Amount', 'sum'], // Sum Amount
                },
            });
            $$('treetable').data.group({
                by: 'CurrencyId', // Group by Currency ID
                map: {
                    CurrencyId: ['CurrencyId'],
                    AmountBase: ['AmountBase', 'sum'], // Sum AmountBase
                    AmountPaid: ['AmountPaid', 'sum'], // Sum AmountPaid
                    PlatformCost: ['PlatformCost', 'sum'], // Sum PlatformCost
                    Amount: ['Amount', 'sum'], // Sum Amount
                },
            });
        });

        // Event handler for filtering data
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item data
            this.$scope.app.callEvent('deposit:id', [item.Id]); // Trigger event with item ID
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
